export const INITIAL_SLUG = "full-list";
export const SLUG_STORAGE_KEY = "tx_slugs";
